import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

@Pipe({
  name: 'submitButtonLabel',
})
export class SubmitButtonLabelPipe implements PipeTransform {
  transform(isEditMode: boolean): string {
    return isEditMode ? 'COMMON.EDIT' : 'COMMON.CREATE_NEW';
  }
}
